import { DialogContent, DialogTitle } from '@mui/material';
import { BaseDialog } from '../dialogs/BaseDialog';
import { CreateEditDialogHeader, CreateEditDialogHeaderProps } from './CreateEditDialogHeader';
import { StyledDialogActions } from '../StyledDialogActions';

interface CreateEditDialogProps {
  open: boolean;
  onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  HeaderProps: CreateEditDialogHeaderProps;
  children: React.ReactElement;
  sx?: any;
  actionsSection?: React.ReactElement;
}

export const CreateEditDialog = ({
  open,
  onClose,
  HeaderProps,
  children,
  sx,
  actionsSection,
}: CreateEditDialogProps) => {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      disableBackdropClickClose
      sx={{
        ...sx,
        '& .MuiDialog-paper': {
          width: '100%',
        },
      }}
    >
      <DialogTitle sx={{ paddingBottom: '32px' }}>
        <CreateEditDialogHeader {...HeaderProps} />
      </DialogTitle>
      <DialogContent sx={{ paddingTop: 4 }}>{children}</DialogContent>
      {actionsSection && <StyledDialogActions>{actionsSection}</StyledDialogActions>}
    </BaseDialog>
  );
};
